// extracted by mini-css-extract-plugin
export default {"activityBanner":"index_activityBanner_ui8EB","activityBannerImg":"index_activityBannerImg_9yzk-"};